import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ThemeProvider, StyledEngineProvider, createTheme } from '@mui/material/styles';
import { BrowserRouter as Router, Route } from 'react-router-dom';

// datapunk

import AgentOntologyPage from './pages/AgentOntology/AgentOntologyPage';
import AuthPage from './pages/Auth/AuthPage';
import ActionsLog from './pages/Log/ActionsLog';
import AccountsPage from './pages/Accounts/AccountsPage';
import AppSettingsPage from './pages/AppSettings/AppSettingsPage';
import AncestorsPage from './pages/Ancestors/AncestorsPage';
import BroadcasterPage from './pages/Broadcaster/BroadcasterPage';
import CreateNodePage from './pages/Create/CreateNodePage';
import CronPage from './pages/Cron/CronPage';
import CustomWrapperPage from './pages/WrapperPage/CustomWrapperPage';
import DashboardWrapper from './pages/Dashboard/DashboardWrapper';
import DeleteNodePage from './pages/DeleteNodePage/DeleteNodePage';
import DictionaryPage from './pages/Dictionary/DictionaryPage';
import DriverChatPage from './pages/DriverChat/DriverChatPage';
import FineTuningDatasetPage from './pages/FineTuningDatasetPage/FineTuningDatasetPage';
import EventsPage from './pages/Events/EventsPage';
import FlowEdit from './pages/Flow/FlowEdit';
import FlowPage from './pages/Flow/FlowPage';
import ImportsPage from './pages/Imports/ImportsPage';
import MenuWrapper from './common/MenuWrapper';
import NodePage from './pages/NodePage/NodePage';
import Notifications from './pages/Notifications/NotificationsContainer';
import ParserPage from './pages/Parser/ParserPage';
import Playground from './pages/Playground/Playground';
import RestrictionsPage from './pages/Restrictions/RestrictionsPage';
import ServicesPage from './pages/Services/ServicesPage';
import TableAndForm from './pages/UIEdit/TableAndForm';
import TrplsPage from './pages/Trpls/TrplsPage';
import TrplsTablePage from './pages/TrplsTable/TrplsTablePage';
import Validator from './pages/Validator/Validator';
import TimeZones from './pages/TimeZone/TimeZones';
import SystemIndicators from './pages/System/SystemIndicators';
import UIEditPage from './pages/UIEdit/UIEditPage';
import UnsubscribePage from './Unsubscribe/UnsubscribePage';
import UserLastActivity from './pages/UserLastActivity/UserLastActivityPage';
import UserTutorialPage from './pages/UserTutorial/UserTutorialPage';
import SignupPage from './pages/SignUp/SignupPage';

import { reduxStore } from './reducer/store';
import MatchingPage from './pages/Matching/MatchingPage';
import MatchingPage2 from './pages/Matching/MatchingPage2';
import UnsubscriptionsPage from './pages/Unsubscriptions/UnsubscriptionsPage';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#4B4F73',
    },
  },
  typography: {
    fontFamily: '"Open Sans", sans-serif !important',
    fontSize: 12,
    fontWeight: 400,
    //htmlFontSize: 12,
    allVariants: {
      WebkitFontSmoothing: 'subpixel-antialiased',
      MozOsxFontSmoothing: 'auto',
      textRendering: 'optimizeLegibility',
    },
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          border: 'none',
        },
        input: {
          fontSize: 12,
          display: 'flex',
          border: 'none',
          height: '23px',
          padding: '0 5px',
          fontFamily: '"Urbanist", sans-serif !important',
          transition: 'background 0.2s ease-in-out',
          '&::placeholder': { color: '#4B4F73', fontStyle: 'italic' },
        },
        root: {
          border: 'none',
          minHeight: '23px',
          borderRadius: '0px',
          paddingRight: '0px',
          transition: 'background 0.2s ease-in-out',
        },
      }
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          height: '23px',
          padding: '0',
          fontFamily: '"Urbanist", sans-serif !important',
          transition: 'background 0.2s ease-in-out',
        },
        select: {
          display: 'flex',
          alignItems: 'center',
          fontSize: 12,
          height: '23px',
          border: 'none',
          minWidth: '15px',
          minHeight: '23px',
          borderRadius: '0px',
          paddingRight: '20px !important',
          fontFamily: '"Urbanist", sans-serif !important',
          '&::placeholder': { color: '#4B4F73', fontStyle: 'italic' },
        },
        icon: {
          right: '1px',
        },
      }
    },
    MuiButton: {
      root: {
        fontFamily: '"Urbanist", sans-serif !important',
      }
    },
    MuiButtonBase: {
      root: {
        fontFamily: '"Urbanist", sans-serif !important',
      }
    },
    MuiInputBase: {
      root: {
        fontFamily: '"Urbanist", sans-serif !important',
      }
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          width: '-webkit-fill-available',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        formControl: {
          fontSize: 11,
          position: 'relative',
          transform: 'none',
        },
      },
    },
    MuiInputAdornment: {
      styleOverrides: {
        root: {
          marginLeft: '0px',
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          marginRight: 0,
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          fontSize: '20px',
          color: '#5D5F77',
          cursor: 'pointer',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          border: 'none',
          fontFamily: '"Urbanist", sans-serif',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontFamily: '"Urbanist", sans-serif',
          minHeight: '36px',
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          fontFamily: '"Urbanist", sans-serif',
          color: '#4c4c4c',
          minHeight: '36px',
        },
      },
    },
  },
});

const Routes = () => (
  <Router>
    <Provider store={reduxStore}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <Notifications>
            <MenuWrapper>
              <Route path="/app" component={AppSettingsPage} />
              <Route path="/agent_ontology" component={AgentOntologyPage} />
              <Route path="/frm" component={TableAndForm} />
              <Route path="/tbl" component={TrplsTablePage} />
              <Route path="/node/:nodeId" component={NodePage} />
              <Route path="/rst_edit" component={RestrictionsPage} />
              <Route path="/matching" component={MatchingPage} />
              <Route path="/matching2" component={MatchingPage2} />
              <Route path="/imports" component={ImportsPage} />
              <Route path="/auth" component={AuthPage} />
              <Route path="/signup" component={SignupPage} />
              <Route path="/flow" component={FlowEdit} />
              <Route path="/cron" component={CronPage} />
              <Route path="/flows" component={FlowPage} />
              <Route path="/fine_tuning_dataset" component={FineTuningDatasetPage} />
              <Route path="/trpls" component={TrplsPage} />
              <Route path="/events" component={EventsPage} />
              <Route path="/parsers" component={ParserPage} />
              <Route path="/ui_edit" component={UIEditPage} />
              <Route path="/l10n" component={DictionaryPage} />
              <Route path="/chat" component={DriverChatPage} />
              <Route path="/playground" component={Playground} />
              <Route path="/services" component={ServicesPage} />
              <Route path="/accounts" component={AccountsPage} />
              <Route path="/ancestors" component={AncestorsPage} />
              {/* <Route path="/dashboard"
                component={window.location.host === 'mlkwb.ai' ? DashboardAiPage : DashboardPage} /> */}
              <Route path="/dashboard" component={DashboardWrapper} />
              <Route path="/create_node" component={CreateNodePage} />
              <Route path="/delete_node" component={DeleteNodePage} />
              <Route path="/broadcaster" component={BroadcasterPage} />
              <Route path="/user_last_activity" component={UserLastActivity} />
              <Route path="/unsubscriptions" component={UnsubscriptionsPage} />
              <Route path="/unsubscribe" component={UnsubscribePage} />
              <Route path="/actions_log" component={ActionsLog} />
              <Route path="/validator" component={Validator} />
              <Route path="/timezones" component={TimeZones} />
              <Route path="/system" component={SystemIndicators} />
              <Route path="/tutorial" component={UserTutorialPage} />
              <Route path="/addon/:addon" component={CustomWrapperPage} />
            </MenuWrapper>
          </Notifications>
        </ThemeProvider>
      </StyledEngineProvider>
    </Provider>
  </Router>
);

ReactDOM.render(<Routes />, document.querySelector('#react-app'));
